/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { DictionaryItemDto, GlobalDictionaryDto } from './dictionary-item.dto';

export const DictionaryItemMapper = entity<DictionaryItemDto>();
export const GlobalDictionaryItemMapper = entity<GlobalDictionaryDto>();
